module.exports = __webpack_public_path__ + "img/successpoint.4b464053.png";